<template>
  <transition name="ae-fade">
    <div>
      <div class="wt-sot-subtitles">
        <div class="wt-sot-subtitles-header">Add Subtitles</div>
        <div class="wt-sot-subtitles-inner">
          <textarea v-model="tmpSubtitles" ref="textInput" />
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import bus from 'v/AssetEditor/AssetEditorEventBus';
import PageMixin from 'AssetEditor/pages/PageMixin.vue';
import { mapActions, mapMutations } from 'vuex';

/** (GW)
 * Asset Editor's subttles editor vue (left bar)
 */
export default {
  data: function () {
    return {
      tmpSubtitles: this.$store.state.assetEditor.tmpAGD.videoQuoteSubTitles,
    };
  },

  mixins: [PageMixin],

  beforeDestroy: function () {
    bus.$off('apply', this.apply);
  },

  mounted: function () {
    this.focusInput();
    bus.$on('apply', this.apply);
  },

  methods: {
    ...mapActions('assetEditor', ['changeCurrentPage', 'removePage']),
    ...mapMutations('assetEditor', ['setAGD']),

    focusInput: function () {
      this.$nextTick(function () {
        this.$refs.textInput.focus();
      });
    },

    backToPreview() {
      this.askSaveChanges(
        this.$store.state.assetEditor.tmpAGD.videoQuoteSubTitles !==
          this.tmpSubtitles
      );
    },

    apply: function () {
      if (_.isEmpty(this.tmpSubtitles.trim())) {
        this.removePage('subtitles');
      } else {
        this.setAGD({
          videoQuoteSubTitles: this.tmpSubtitles,
        });
      }
      this.changeCurrentPage('preview');
    },
  },
};
</script>
